<template>
  <div class="card mt-3">
    <div class="card-body">
      <h5 class="card-title">
        {{ trans("admin.cdr.dismissedTitle") }}
      </h5>

      <div class="row">
        <div class="col-md-6">
          <strong>{{ trans("admin.cdr.dismissedBy") }}:</strong>
          {{ dismissal.dismissed_by_name }}
        </div>
        <div class="col-md-6">
          <strong>{{ trans("admin.cdr.dismissedAt") }}:</strong>
          {{ dismissal.dismissed_at_formatted }}
        </div>
      </div>

      <div v-if="dismissal.dismissal_note" class="mt-3">
        <strong>{{ trans("admin.cdr.dismissalNote") }}:</strong>
        <p class="mb-0">{{ dismissal.dismissal_note }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dismissal: { type: Object, required: true },
  },
};
</script>
